<template>
  <div class="header navbar navbar-inverse">
    <div class="navbar-inner">
      <div class="header-seperation">
        <ul
          class="nav pull-left notifcation-center"
          id="main-menu-toggle-wrapper"
        >
          <li class="dropdown">
            <a id="main-menu-toggle" class="main-menu-toggle">
              <div class="iconset top-menu-toggle-white"></div>
            </a>
          </li>
        </ul>
        <a>
          <h4 class="text-white text-center" style="padding-top: 8px">
            <span class="bold" style="margin-left: -72px">Befeni</span>
            Production
          </h4>
          <!--<img src="/assets/img/logo.png" class="logo" alt="" data-src="/assets/img/logo.png" data-src-retina="/assets/img/logo2x.png" height="40" style="position: relative; top: -7px;" />-->
        </a>
      </div>
      <div class="header-quick-nav">
        <div class="pull-left">
          <ul class="nav quick-section">
            <li class="quicklinks">
              <a href="#" class="" id="layout-condensed-toggle">
                <div class="iconset top-menu-toggle-dark"></div>
              </a>
            </li>
          </ul>
          <ul class="nav quick-section">
            <li class="m-r-10 input-prepend inside search-form no-boarder">
              <span class="add-on">
                <span class="iconset top-search"></span
              ></span>
              <input
                name=""
                type="text"
                @keyup.enter="shirtDetail"
                class="no-boarder"
                placeholder="Search Shirt Order"
                style="width: 250px"
              />
            </li>
          </ul>
        </div>
        <div class="pull-right" v-if="$auth.check()">
          <ul class="nav quick-section">
            <li class="m-r-10 input-prepend inside search-form no-boarder">
              <span class="add-on">
                <span class="iconset top-search"></span
              ></span>
              <input
                name=""
                type="text"
                @keyup.enter="searchFabric"
                class="no-boarder"
                placeholder="Search Fabric"
                style="width: 250px"
              />
            </li>
          </ul>

          <ul class="nav quick-section">
            <li class="quicklinks">
              <a
                data-toggle="dropdown"
                class="dropdown-toggle pull-right"
                href="#"
                id="user-options"
              >
                <!-- <div class="iconset top-down-arrow" style="top: 4px;"></div> -->
                <div class="username text-black">
                  {{ $auth.user().first_name }}
                  <span class="bold">{{ $auth.user().last_name }}</span>
                  &nbsp;<i class="fa fa-caret-down" aria-hidden="true"></i>
                </div>
              </a>
              <ul
                class="dropdown-menu pull-right"
                role="menu"
                aria-labelledby="user-options"
              >
                <li>
                  <a href="" @click.prevent="logout"
                    ><i class="fa fa-power-off"></i>&nbsp;&nbsp;Log Out</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    async shirtDetail(event) {
      let shirtOrderId = event.target.value
      if (!shirtOrderId) {
        toastr.error("Please enter shirt order ID");
      } else {
        try {
          let res = await axios.get("shirt_orders/detail/" + shirtOrderId);
          if(res) {
            this.$router.push("/shirt/detail/" + shirtOrderId);
          }
        } catch (error) {
          switch (error.response.status) {
            case 403:
              toastr.error("Not authorized, please ensure that you have the required permissions.");
              break;
            case 422:
              toastr.error(error.response.data.errors.shirtOrderId);
              break;
            default:
              Swal.fire("# " + shirtOrderId, error.response.data.message, "error");
              break;
          }
        }
      }
      event.target.value = null;
    },
    searchFabric($event) {
      this.$router.push("/fabric/update/" + $Fabric.getId($event.target.value));
      $event.target.value = null;
    },
    /**
     * Perform a custom logout
     * @param event
     * @returns {Promise<void>}
     */
    async logout(event) {
      try {
        await axios.post("/auth/logout", {
          /**
           * Send back the APIv2 access token so we can revoke it properly without wiping out everything
           */
          "token-v2": localStorage.getItem("authorization"),
        });
        localStorage.removeItem("authorization");
        window.location.href = "/login";
      } catch (e) {}
    },
  },
};
</script>
